import React from 'react';
import './ProjectInfoModal.css';

const ProjectInfoModal = ({ open, onClose, title, description, banner, projectLink }) => {
  if (!open) return null;
  return (
    <div className="project-info-modal__overlay" onClick={onClose}>
      <div className="project-info-modal" onClick={e => e.stopPropagation()}>
        <button className="project-info-modal__close" onClick={onClose}>&times;</button>
        <div className="project-info-modal__content">
          <h2>{title}</h2>
          <p>{description}</p>
          {projectLink && (
            <a href={projectLink} className="project-info__link" target="_blank" rel="noopener noreferrer">
              Läs mer
            </a>
          )}
        </div>
        {banner && (
          <div className="project-info-modal__image">
            <img src={banner} alt={title} />
          </div>
        )}
      </div>
    </div>
  );
};

export default ProjectInfoModal;
